/**
 * Tipos de features disponibles
 */
export enum FeatureType {
  MODAL = 'modal',
  TOOLTIP = 'tooltip',
  TOUR = 'tour',
  SPOTLIGHT = 'spotlight',
  BANNER = 'banner',
}

/**
 * Media de un slide (imagen o video)
 */
export interface FeatureSlideMedia {
  type: 'image' | 'video';
  url: string;
}

/**
 * Slide de un feature tipo modal
 */
export interface FeatureSlide {
  title: string;
  description?: string;
  media?: FeatureSlideMedia;
  icon?: string;
}

/**
 * Configuración de botones del modal
 */
export interface FeatureModalButtons {
  next?: string;
  prev?: string;
  accept?: string;
}

/**
 * Configuración específica para features tipo MODAL
 */
export interface FeatureModalConfig {
  slides: FeatureSlide[];
  buttons?: FeatureModalButtons;
  /** Mostrar nombre del usuario en el primer slide */
  showUserName?: boolean;
}

/**
 * Configuración específica para features tipo TOOLTIP
 */
export interface FeatureTooltipConfig {
  targetSelector: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

/**
 * Configuración específica para features tipo BANNER
 */
export interface FeatureBannerConfig {
  icon?: string;
  actionUrl?: string;
  actionText?: string;
}

/**
 * Configuración específica para features tipo SPOTLIGHT
 */
export interface FeatureSpotlightConfig {
  /** Selector CSS del elemento a resaltar */
  targetSelector: string;
  /** Posición del FloatingHint respecto al elemento */
  position?: 'top' | 'bottom' | 'left' | 'right';
  /** Título del mensaje (opcional) */
  title?: string;
  /** Mensaje descriptivo */
  message: string;
  /** Mostrar backdrop oscuro detrás del spotlight */
  showBackdrop?: boolean;
  /** Usar trigger manual en lugar de automático basado en targetSelector */
  useManualTrigger?: boolean;
  /** Hacer scroll automático al elemento target antes de mostrar el spotlight */
  scrollToTarget?: boolean;
}

/**
 * Unión de todas las configuraciones posibles
 */
export type FeatureConfig =
  | FeatureModalConfig
  | FeatureTooltipConfig
  | FeatureBannerConfig
  | FeatureSpotlightConfig
  | null;

/**
 * Feature del sistema de novedades/tutoriales
 */
export interface Feature {
  id: number;
  feature_key: string;
  title: string | null;
  description: string | null;
  type: FeatureType;
  config: FeatureConfig;
  module: string | null;
  priority: number;
  show_until: string | null;
}

/**
 * Respuesta del endpoint de marcar múltiples features como vistos
 */
export interface MarkMultipleViewedResponse {
  success: boolean;
  message: string;
  count: number;
}
